<template>
  <div>
    <VaNavbar class="app-layout-navbar py-2 px-0">
      <template #left>
        <div class="left">
          <Transition v-if="isMobile" name="icon-fade" mode="out-in">
            <VaIcon
              color="primary"
              :name="isSidebarMinimized ? 'menu' : 'close'"
              size="24px"
              style="margin-top: 3px"
              @click="isSidebarMinimized = !isSidebarMinimized"
            />
          </Transition>
          <RouterLink to="/" aria-label="Visit home page">
            <!--VuesticLogo /-->
            <SpreadLogo class="xs:h-20 sm:h-28 lg:h-40" start="#0E41C9" />
          </RouterLink>
        </div>
      </template>
      <template #right>
        <div class="flex items-center gap-2">
          <VaChip v-if="store.mode === 'organiser'" size="small" color="warning">
            <VaIcon name="mso-store" size="14px" :class="{ 'mr-1': true }" />
            <span class="hidden sm:inline">Organiser mode</span>
          </VaChip>
          <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" />
        </div>
      </template>
    </VaNavbar>
    <div
      v-if="showOrganiserHint"
      class="flex items-center justify-between gap-2 px-6 py-2 text-sm bg-[var(--va-background-element)] border-b border-[var(--va-background-border)]"
    >
      <span>
        <VaIcon name="mso-store" size="16px" class="mr-1 text-primary" />
        Want to organise an event?
        <span class="font-semibold text-primary cursor-pointer ml-1" @click="switchToOrganiser"
          >Switch to organiser mode</span
        >
      </span>
      <VaButton preset="plain" icon="close" size="small" color="secondary" @click="store.dismissOrganiserHint()" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import { useGlobalStore } from '../../stores/global-store'
import AppNavbarActions from './components/AppNavbarActions.vue'
import SpreadLogo from '../SpreadLogo.vue'
import { useUserStore } from '@/stores/user-store'

const store = useUserStore()
store.retrieveUserinfo()

defineProps({
  isMobile: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()
const { isSidebarMinimized } = storeToRefs(GlobalStore)
const { push } = useRouter()

const showOrganiserHint = computed(
  () => !store.organiserHintSeen && store.mode === 'fan' && ['organiser', 'admin', 'sa'].includes(store.role),
)

const switchToOrganiser = () => {
  store.setMode('organiser')
  push({ name: 'managed-events' })
}
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 2;

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
</style>
